module.exports = __webpack_public_path__ + "static/media/sparkle-left.dc993032.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/sparkle-left.svg
// module id = 530
// module chunks = 49